import { FullProject, QuotationRequest } from 'entities';

import { InvoiceControlCreation } from './types';
import { calculateAvailableAmount, getExactDecimal } from '../utils';

export function calculateInvoiceValues({ value, discountRequest }: InvoiceControlCreation): {
  appliedDiscount: number;
  total: number;
} {
  const appliedDiscount =
    discountRequest?.type === 'VALUE'
      ? Number(discountRequest.value)
      : Number(value) * (Number(discountRequest?.percentage) / 100);

  return {
    appliedDiscount,

    total: (Number(value) || 0) - (appliedDiscount || 0),
  };
}

function validateDiscountPercentageIsInvalid(percentage: string): boolean {
  const MIN = 0;
  const MAX = 100;
  const value = Number(percentage);

  const invalid = [!value, value < MIN, value > MAX].some(Boolean);

  return invalid;
}

export function validateDiscount(
  request:
    | Pick<
        NonNullable<InvoiceControlCreation['discountRequest']>,
        'percentage' | 'salesDefined' | 'type' | 'value'
      >
    | undefined,
  totalValue: number,
): boolean {
  if (!request) return true;

  if (request.salesDefined) return request.percentage === '0.00';

  const isPercentage = request.type === 'PERCENTAGE';

  if (isPercentage) return !validateDiscountPercentageIsInvalid(request.percentage);

  const valueDiscount = Number(request.value);

  return !!valueDiscount && valueDiscount <= totalValue;
}

export function validateCanCreate(
  project: FullProject,
  { client, country, extraInformation, value, discountRequest }: InvoiceControlCreation,
  quotationRequest: QuotationRequest | null,
): boolean {
  const availableAmount = calculateAvailableAmount(project);

  const selectedValueIsOk = quotationRequest
    ? true
    : !!value && getExactDecimal(value) <= availableAmount;

  const canCreate = [
    selectedValueIsOk,
    country,
    client,
    extraInformation,
    discountRequest ? validateDiscount(discountRequest, getExactDecimal(value)) : true,
  ].every(Boolean);

  return canCreate;
}
